/**
 * Avalara © 2018
 * file: engines/opus_ui/src/search/BusinessLicensesCard.jsx
 */

import React, { Component } from 'react';
import { Link } from 'react-router-dom';

const notAvailableResultItem = (
  <s-row>
    <s-col>Not available</s-col>
  </s-row>
);

class BusinessLicensesCard extends Component {
  render() {
    const { data } = this.props;
    if (!data.details) {
      data.details = [];
    }

    return (
      <div className="Section">
        <div className="Card">
          <div className="SectionTitle">
            <div>
              Business Licenses
              <h1>{data.BLAccountID}</h1>
            </div>
          </div>
          <div className="ResultsSection">
            <div className="DeliveryResultsSection">
              <table>
                <tbody>
                  <tr>
                    <td>Customer Account Id</td>
                    <td>
                      <Link
                        className="Link"
                        to={`search?query=${data.customerAccount.id}`}
                      >
                        {data.customerAccount.id}
                      </Link>
                    </td>
                  </tr>
                  <tr>
                    <td>provisioningContact</td>
                    <table>
                      <thead>
                        <tr>
                          <td>First Name</td>
                          <td>Last Name</td>
                          <td>Email</td>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>{data.first_name}</td>
                          <td>{data.last_name}</td>
                          <td>{data.email}</td>
                        </tr>
                      </tbody>
                    </table>
                  </tr>
                  <tr>
                    <td>Details</td>
                  </tr>
                  <tr>
                    <td>
                      {data.AvalaraOrders
                        ? data.AvalaraOrders.map((d) => (
                            <fieldset>
                              <legend style={{ textTransform: 'none' }}>
                                Avalara Order ID:&nbsp;&nbsp;&nbsp;&nbsp;
                                {d.AvalaraOrderID}
                              </legend>
                              <table>
                                <thead>
                                  <tr>
                                    <td>order id</td>
                                    <td>SKU</td>
                                  </tr>
                                </thead>
                                <tbody>
                                  {d.SKUs.map((s) => (
                                    <tr>
                                      <td>{s.Orders.order_id}</td>
                                      <td>{s.SKU}</td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </fieldset>
                          ))
                        : notAvailableResultItem}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default BusinessLicensesCard;
